import { render, staticRenderFns } from "./CompaniesEdit.vue?vue&type=template&id=2742f1f9"
import script from "./CompaniesEdit.vue?vue&type=script&lang=js"
export * from "./CompaniesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports